import { convertToProcessingState } from '../../../../graphql/tourSceneConverter';
import { TourBuilderStoreEvents } from '../../events/TourBuilderStoreEvents';
import { TourBuilderStoreIoC } from '../../tourBuilderIoC';
import { TourBuilderStore } from '../../tourBuilderStore';
import { Scene, SceneGuid, SceneHelper } from '../../types/Scene';

export type ReplaceSceneUseCase = {
  sceneGuid: SceneGuid;
  tourId: number;
  panoramaId: number;
};

export const replaceSceneUseCase = async (
  params: ReplaceSceneUseCase,
  getState: () => TourBuilderStore,
  services: TourBuilderStoreIoC,
  eventHandlers: TourBuilderStoreEvents
): Promise<Partial<TourBuilderStore>> => {
  const store = getState();
  const sceneToUpdate = store.scenes.get(params.sceneGuid);
  if (!sceneToUpdate) {
    return store;
  }

  const result = await services.storageClient.updateTourSceneRenderSettings({
    tourId: params.tourId,
    panoramaSceneId: params.panoramaId,
    tourSceneGuid: params.sceneGuid,
  });

  const replacedData = result.ReplaceTourScenePanorama.tourScene;
  if (!replacedData) {
    return store;
  }

  const renderSettings = replacedData.sceneRenderSettings ?? SceneHelper.getDefaultRenderSettings();
  const updatedScene = SceneHelper.changeUnderlyingPanorama(
    sceneToUpdate,
    replacedData.name,
    replacedData.thumbnailUrl,
    convertToProcessingState(replacedData.hasProcessingFinishedSuccessfully),
    renderSettings
  );

  const newScenes = new Map<SceneGuid, Scene>(store.scenes);
  newScenes.set(updatedScene.guid, updatedScene);

  eventHandlers.onSceneReplaced.notify({
    guid: updatedScene.guid,
    renderSettings,
  });

  return {
    scenes: newScenes,
  };
};
